import { EpiPage } from '@api/types';
import { NoResults, PageListItem } from '@components';
import { Box, styled } from '@mui/material';
import { breakpoints, spacing } from '@themes/theme.helpers';
import { ReactNode } from 'react';

// STYLES
//--------
const PageListWrapper = styled(Box)`
  display: grid;
  gap: ${spacing(2)};
  ${breakpoints.up('md')} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: max-content;
    gap: ${spacing(2)} ${spacing(2)};
  }
  ${breakpoints.up('lg')} {
    grid-template-columns: 1fr 1fr 1fr;
    gap: ${spacing(2)} ${spacing(2)};
  }
`;

// TYPES
//-------
export type PageListProps = {
  children?: ReactNode;
  blocks?: Array<EpiPage>;
  useCard?: boolean;
  isWorking?: boolean;
};

// COMPONENTS
//------------
export const PageList = ({ children, useCard, blocks = [], isWorking }: PageListProps) => {
  return (
    <PageListWrapper>
      {blocks?.map((block, key) => (
        <PageListItem block={block} key={key} useCard={useCard} isWorking={isWorking} />
      ))}
      {children}
      {!children && blocks?.length === 0 && <NoResults />}
    </PageListWrapper>
  );
};
